import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class Register {
  constructor() {
    document
      .querySelector('#registerScr #freplayBtn')
      .addEventListener('click', this.replayGame.bind(this));

    document
      .querySelector('#registerScr #fsubmitBtn')
      .addEventListener('click', this.onRegisterSubmit.bind(this, false));
  }
  init() {
    this.isVisible = false;
    this.proceeded = false;
    this.registered = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
      case 'hide_home':
        this.hideScreen(data['message']['data']);
        break;
    }
  }
  hideScreen(data) {
    if (!this.isVisible) return;

    this.isVisible = false;
    // this.introRotateTwn.kill();

    console.log('Register hideScreen');

    gsap.delayedCall(0.1, () => {
      document.querySelector('#registerScr').classList.remove('active2');
    });
    gsap.delayedCall(0.5, () => {
      document.querySelector('#registerScr').classList.remove('active');
    });
  }
  replayGame() {
    if (!this.isVisible) return;

    this.hideScreen();
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'replay_game',
        data: {},
      },
    });
    //
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Register') return false;

    this.isVisible = true;
    document.querySelector('#registerScr').classList.add('active');

    gsap.delayedCall(0.5, () => {
      document.querySelector('#registerScr').classList.add('active2');
      //   document.querySelector('#instrScr .title').classList.add('active');
    });
    gsap.delayedCall(0.2, this.animate.bind(this));
  }
  animate() {}
  async onRegisterSubmit() {
    if (this.registered) return false;

    let isValid = this.validate();

    if (!isValid) return false;

    this.registered = true;

    localStorage.setItem('userName', Global.userName);
    localStorage.setItem('mobile', Global.mobile);
    // localStorage.setItem('email', Global.email);
    // localStorage.setItem('location', Global.location);
    // localStorage.setItem('IGHandle', Global.IGHandle);

    Global.scoreSubmitted = true;

    this.showNextScreen();
    return;
    // const result = await register(
    //   Global.userName,
    //   Global.email,
    //   Global.mobile,
    //   Global.state
    // );

    if (result.statusCode !== 200) {
      document
        .querySelector('#register_screen #name')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #mobile')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #email')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #location')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #ig_handle')
        .parentElement.classList.remove('error');

      this.registered = false;
      //totalLimitExceeded

      if (result.messageId === 'invalidName') {
        document
          .querySelector('#register_screen #name')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidMobile') {
        document
          .querySelector('#register_screen #mobile')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidEmail') {
        document
          .querySelector('#register_screen #email')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidLocation') {
        document
          .querySelector('#register_screen #location')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidIGHandle') {
        document
          .querySelector('#register_screen #ig_handle')
          .parentElement.classList.add('error');
      }
      document.querySelector('.errorSec').innerHTML = result.message;
      document.querySelector('.errorSec').classList.add('active');
      this.errorTO && clearTimeout(this.errorTO);
      this.errorTO = setTimeout(() => {
        document.querySelector('.errorSec').classList.remove('active');
      }, 1000);
      return false;
    }

    this.showNextScreen();
  }
  showNextScreen() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'Score',
        },
      },
    });
  }
  validate() {
    let isValid = true;
    Global.userName = document.querySelector('#registerScr #name').value.trim();
    Global.mobile = document.querySelector('#registerScr #mobile').value.trim();
    Global.email = document.querySelector('#registerScr #email').value.trim();

    if (Global.userName.length == 0) {
      document
        .querySelector('#registerScr #name')
        .parentElement.classList.add('error');
      isValid = false;
      document.querySelector('.errorSec').innerHTML = 'Invalid Name.';
    } else {
      document
        .querySelector('#registerScr #name')
        .parentElement.classList.remove('error');
    }

    if (Global.email.length != 0) {
      if (
        !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Global.email) &&
        isValid
      ) {
        document
          .querySelector('#registerScr #email')
          .parentElement.classList.add('error');
        document.querySelector('.errorSec').innerHTML = 'Invalid Email.';
        isValid = false;
      } else if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Global.email)
      ) {
        document
          .querySelector('#registerScr #email')
          .parentElement.classList.remove('error');
      }
    } else {
      document
        .querySelector('#registerScr #email')
        .parentElement.classList.add('error');
      document.querySelector('.errorSec').innerHTML = 'Invalid Email.';
      isValid = false;
    }

    if ((Global.mobile.length == 0 || isNaN(Global.mobile)) && isValid) {
      document
        .querySelector('#registerScr #mobile')
        .parentElement.classList.add('error');
      isValid = false;
      document.querySelector('.errorSec').innerHTML = 'Invalid Mobile Number.';
    } else {
      document
        .querySelector('#registerScr #mobile')
        .parentElement.classList.remove('error');
    }

    // if (Global.location.length == 0 && isValid) {
    //   document
    //     .querySelector('#register_screen #location')
    //     .parentElement.classList.add('error');
    //   document.querySelector('.errorSec').innerHTML = 'Invalid Location.';
    //   isValid = false;
    // } else {
    //   document
    //     .querySelector('#register_screen #location')
    //     .parentElement.classList.remove('error');
    // }
    // if (Global.IGHandle.length == 0 && isValid) {
    //   document
    //     .querySelector('#register_screen #ig_handle')
    //     .parentElement.classList.add('error');
    //   document.querySelector('.errorSec').innerHTML = 'Invalid IG Handle.';
    //   isValid = false;
    // } else {
    //   document
    //     .querySelector('#register_screen #ig_handle')
    //     .parentElement.classList.remove('error');
    // }

    if (!isValid) {
      this.errorTO && clearTimeout(this.errorTO);
      document.querySelector('.errorSec').classList.add('active');
      this.errorTO = setTimeout(() => {
        document.querySelector('.errorSec').classList.remove('active');
      }, 1000);
    }

    return isValid;
  }
}
